import '.a{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.cz{border-radius:0.75rem;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import '.d0{font-size:1.125rem;}.ssr-plugin'
import '.me{min-height:1.75rem;}.ssr-plugin'
import '.ap{flex-grow:1;}.ssr-plugin'
import '.l{padding:0px;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.d2{outline:none;}.ssr-plugin'
import '.d3{background:transparent;}.ssr-plugin'
import '.mf{field-sizing:content;}.ssr-plugin'
import '.mb{font-family:inherit;}.ssr-plugin'
import '.fi{line-height:1.75rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.b8{overflow-wrap:break-word;}.ssr-plugin'
import '.b9{word-break:break-word;}.ssr-plugin'
import '.mg{hyphens:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef, KeyboardEventHandler, FocusEventHandler } from 'react'
import { InputField } from '../InputField'

export type TextAreaProps = {
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  label?: string
  labelStyle?: Style
  tooltipText?: string
  required?: boolean
  disabled?: boolean
  errorMessage?: string
  style?: Style
  containerStyle?: Style
  maxLength?: number
  autoResize?: boolean
  onFocus?: FocusEventHandler<HTMLTextAreaElement>
  onBlur?: FocusEventHandler<HTMLTextAreaElement>
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      value,
      onChange,
      placeholder,
      label,
      labelStyle,
      tooltipText,
      required,
      disabled,
      errorMessage,
      style,
      containerStyle,
      maxLength,
      autoResize,
      onFocus,
      onBlur,
      onKeyDown,
    }: TextAreaProps,
    ref,
  ) => {
    const errorStateOn = !disabled && !!errorMessage

    return (
      <InputField
        label={label}
        labelStyle={labelStyle}
        tooltipText={tooltipText}
        required={required}
        errorMessage={errorStateOn ? errorMessage : undefined}
        style={style}
      >
        <styled.div className="a t cz aa"
          style={{
            ...containerStyle,
          }}
        >
          <styled.textarea className="d0 me ap l c4 d2 d3 mf mb fi n aa b8 b9 mg"
            ref={ref}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            disabled={disabled}
            maxLength={maxLength}
            style={{
              resize: autoResize ? 'vertical' : 'none',
              '&::placeholder': {
                color: errorStateOn ? 'var(--status-error)' : 'var(--gray-300)',
                userSelect: 'none',
              },
              '&:disabled': {
                cursor: 'not-allowed',
              },
              ...(style as Record<string, unknown>),
            }}
          />
        </styled.div>
      </InputField>
    )
  },
)

TextArea.displayName = 'TextArea'
